
import React, { useEffect, useState } from "react";
import { conceptMap } from "../../utils/concept-enum";
import "../../assets/css/header.css";
import { appConstants } from "../../utils/constants";
/**
 * Dynamically loads the concept specific logo based on the local storage concept numeric value.
 * @returns JSX image
 */
export default function Logo() {
  const [image, setImage] = useState(null);
  let concept = parseInt(localStorage.getItem(appConstants.conceptCode), 10);

  useEffect(() => {
    if (conceptMap.get(concept) !== undefined) {
      const fetchImage = async () => {
        try {
          const response = await import(
            `../../assets/images/${conceptMap.get(concept)}.svg`
          ); // change relative path to suit your needs
          setImage(response.default);
        } catch (err) {
        } finally {
        }
      };

      fetchImage();
    }
  }, [concept]);

  return image !== null ? (
    <img alt="logo" src={image} className="brand-logo" />
  ) : null;
}
